import React from 'react';
import PropTypes from 'prop-types';

import noUserAvatar from '../../../assets/no-avatar-circle.svg?url';
import PhoneIcon from '../../../assets/icon-phone-brown-filled.svg';
import EmailIcon from '../../../assets/icon-email-brown-filled.svg';

import styles from '../../styles/views/components/UserInformation.module.scss';
import EllipsisToolTip from './EllipsisToolTip';

const UserInformation = ({
  photo,
  name,
  role,
  phoneNumber,
  email,
  onTitleClick,
  isRealUser,
}) => (
  <div className={styles.user}>
    <img src={photo.url || noUserAvatar} alt="Avatar" className={styles.userAvatar} />
    <div className={styles.userInfo}>
      <div className={[styles.userName, onTitleClick ? styles.link : ''].join(' ')} onClick={onTitleClick}>{name}</div>
      <div className={styles.role}>{isRealUser ? t(`roles.${role}`, { ns: i18next.Namespace.COMMON }) : role}</div>
      {phoneNumber && (
      <a className={styles.userPhone} href={`tel:${phoneNumber}`}>
        <PhoneIcon />
        <EllipsisToolTip tooltipText={phoneNumber}>
          <span>{phoneNumber}</span>
        </EllipsisToolTip>
      </a>
      )}
      {email && (
      <a className={styles.userEmail} href={`mailto:${email}`}>
        <EmailIcon />
        <EllipsisToolTip tooltipText={email}>
          <span>{email}</span>
        </EllipsisToolTip>
      </a>
      )}
    </div>
  </div>
);

UserInformation.propTypes = {
  photo: PropTypes.shape({ url: PropTypes.string }),
  role: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string,
  email: PropTypes.string,
  name: PropTypes.string.isRequired,
  onTitleClick: PropTypes.func,
  isRealUser: PropTypes.bool,
};

UserInformation.defaultProps = {
  photo: { url: '' },
  phoneNumber: '',
  email: '',
  onTitleClick: null,
  isRealUser: true,
};

export default UserInformation;
